import Icon from '../components/Icon.vue'

Icon.register({"thermometer-full":{"width":256,"height":512,"paths":[{"d":"M224 96C224 43 181 0 128 0S32 43 32 96V299.3C12.2 321.8 0.2 351.1 0 383.3-0.4 453.6 56.8 511.5 127.1 512 127.4 512 127.7 512 128 512 198.7 512 256 454.7 256 384 256 351.5 243.9 321.9 224 299.3V96zM128 464L127.4 464C83.6 463.7 47.8 427.5 48 383.6 48.2 349.6 67.3 331.9 80 317.5V96C80 69.5 101.5 48 128 48S176 69.5 176 96V317.5C188.6 331.8 208 349.7 208 384 208 428.1 172.1 464 128 464zM192 384C192 419.3 163.3 448 128 448S64 419.3 64 384C64 360.3 76.9 339.7 96 328.6V96C96 78.3 110.3 64 128 64S160 78.3 160 96V328.6C179.1 339.7 192 360.3 192 384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/thermometer-full.js
// module id = bcZ0
// module chunks = 0